import {
  COMMISSIONS_SUMMARY_REQUEST_START,
  COMMISSIONS_SUMMARY_REQUEST_SUCCESS,
  COMMISSIONS_SUMMARY_REQUEST_FAIL,
  COMMISSIONS_DETAIL_REQUEST_START,
  COMMISSIONS_DETAIL_REQUEST_FAIL,
  COMMISSIONS_DETAIL_REQUEST_SUCCESS,
  COMMISSIONS_DATA_RESET,
} from './types';

import { post } from './../session/actions';
import { convert, details } from './utils/convert';
import { getServicesErrorObj }  from '../servicesDowntime/actions';

export const COMMISSION_SUMMARY_URL: string = `/v1/affiliate-portal/affiliates/commissions/getcumulativeandgraphdata`;
export const COMMISSION_DETAILS_URL: string = `/v1/affiliate-portal/commissions/gettabulardata`;

export const commissionsSummaryRequestStart = () => ({
  type: COMMISSIONS_SUMMARY_REQUEST_START
});

export const commissionsSummaryRequestFail = () => ({
  type: COMMISSIONS_SUMMARY_REQUEST_FAIL
});

export const commissionsSummaryRequestSuccess = (payload: any) => ({
  type: COMMISSIONS_SUMMARY_REQUEST_SUCCESS,
  payload
});

export const commissionsDetailRequestStart = () => ({
  type: COMMISSIONS_DETAIL_REQUEST_START
});

export const commissionsDetailRequestFail = () => ({
  type: COMMISSIONS_DETAIL_REQUEST_FAIL
});

export const commissionsDetailRequestSuccess = (payload: any) => ({
  type: COMMISSIONS_DETAIL_REQUEST_SUCCESS,
  payload
});

export const commissionsDataReset = () => ({
  type: COMMISSIONS_DATA_RESET
});

export const getCommissionsSummary = (allAffiliateIds: Array<string>) => (
  dispatch: Function
) => new Promise((resolve, reject) => {
  dispatch(commissionsSummaryRequestStart());
  dispatch(
    post(COMMISSION_SUMMARY_URL, {
      affiliate_number: allAffiliateIds
    })
  ).then((response: any) => {
    if (response && response.data) {
      const parsed: any = convert(response.data);
      dispatch(commissionsSummaryRequestSuccess(parsed));
      resolve(parsed);
    } else {
      dispatch(commissionsSummaryRequestFail());
      reject();
    }
  }).catch((error: any) => {
    dispatch(commissionsSummaryRequestFail());
    dispatch(getServicesErrorObj(error));
    reject();
  });
});

export const getCommissionsDetail = (allAffiliateNos: Array<string>, statement: any, commissionsViewType: string, translate: Function) => (
  dispatch: Function
) => new Promise((resolve, reject) => {
  dispatch(commissionsDetailRequestStart());
  dispatch(
    post(COMMISSION_DETAILS_URL, {
      'affiliate_number': allAffiliateNos,
      'statement_year': statement.statementyear,
      'statement_month': statement.statementmonth,
      'statement_number': statement.statementnumber,
      'view_type': commissionsViewType,
      "legal_entity": statement.legalentity
    })
  ).then((response: any) => {
    if (response && response.data) {
      const parsed: any = details(response.data, commissionsViewType, translate);
      dispatch(commissionsDetailRequestSuccess(parsed));
      resolve(parsed);
    } else {
      dispatch(commissionsDetailRequestFail());
      reject();
    }
  }).catch((error: any) => {
    dispatch(commissionsDetailRequestFail());
    dispatch(getServicesErrorObj(error));
    reject();
  });
});

export type CommissionsSummaryAction = {
  type: string,
  payload?: any
};
